/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeaveLeaderboardResponse
 */
export interface LeaveLeaderboardResponse {
    /**
     * 
     * @type {boolean}
     * @memberof LeaveLeaderboardResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof LeaveLeaderboardResponse
     */
    message: string;
    /**
     * The occurrence the entry was released from.
     * @type {number}
     * @memberof LeaveLeaderboardResponse
     */
    periodNumber?: number;
    /**
     * True when an entry fee or a burned entry token was returned. False on a free board, where there was nothing to return.
     * @type {boolean}
     * @memberof LeaveLeaderboardResponse
     */
    refunded?: boolean;
}

/**
 * Check if a given object implements the LeaveLeaderboardResponse interface.
 */
export function instanceOfLeaveLeaderboardResponse(value: object): value is LeaveLeaderboardResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function LeaveLeaderboardResponseFromJSON(json: any): LeaveLeaderboardResponse {
    return LeaveLeaderboardResponseFromJSONTyped(json, false);
}

export function LeaveLeaderboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaveLeaderboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
        'periodNumber': json['periodNumber'] == null ? undefined : json['periodNumber'],
        'refunded': json['refunded'] == null ? undefined : json['refunded'],
    };
}

export function LeaveLeaderboardResponseToJSON(json: any): LeaveLeaderboardResponse {
    return LeaveLeaderboardResponseToJSONTyped(json, false);
}

export function LeaveLeaderboardResponseToJSONTyped(value?: LeaveLeaderboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'periodNumber': value['periodNumber'],
        'refunded': value['refunded'],
    };
}

